import api from './api';

export interface ClassificacaoServico {
  id?: string;
  descricao: string;
  nome: string;
  index: number;
  nivel: number;
  classificacaoServicoPaiId: string | null;
  children?: ClassificacaoServico[];
  indexTexto?: string;
  fmCodigo?: string;
  gerenciadoTotvs?: boolean;
  enabled?: boolean;
}

export const getAll = () => api.get<ClassificacaoServico[]>('classificacaoServico');
export const update = (value: any) => api.put('classificacaoServico', value);
export const excluir = (id: string) => api.delete(`classificacaoServico/${id}`);
export const getUltimaSincronizacao = () => api.get<string | null>('classificacaoServico/ultima-sincronizacao');
export const getClassificacaoServicoForOptions = (id?: string, busca?: string, incluirId?: string) => {
  const parametros = [
    busca ? `busca=${encodeURIComponent(busca)}` : '',
    incluirId ? `incluirId=${encodeURIComponent(incluirId)}` : '',
  ].filter(Boolean);
  const query = parametros.length ? `?${parametros.join('&')}` : '';
  return api
    .get(`classificacaoServico/getSubItens${id ? `/${id}` : ''}${query}`)
    .then(classificacoes =>
      (classificacoes || []).map(c => ({
        text: `${c.fmCodigo ? `${c.fmCodigo} — ` : ''}${c.nome}${c.enabled === false ? ' (inativo)' : ''}`,
        value: c.id.toString(),
        disabled: c.enabled === false,
      })),
    );
};
